export const calendarModes = {
  time: 'time',
  date: 'date'
}
